<template>
  <div
    class="modal modal-widget modal-search fade"
    id="searchModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="searchModalLabel"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <ValidationObserver ref="form" v-slot="{ invalid }">
            <form action="/" method="get">
              <div class="modal-header">
                <h4 class="modal-title" id="searchModalLabel">
                  {{ $t("buttons.search") }}
                </h4>
                <a
                  href="#"
                  class="icon icon-cross"
                  data-dismiss="modal"
                  aria-label="Close"
                  >{{ $t("close") }}</a
                >
              </div>
              <div class="modal-body pb-0">
                <div class="form-group mb-2">
                  <validation-provider
                    name="recherche"
                    rules="required|min:2"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      name="s"
                      v-model="q"
                      class="form-control form-control_search"
                      :placeholder="$t('buttons.search')"
                      :class="{ 'is-invalid': errors.length }"
                    />
                    <span class="text-danger small">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div>
                  <div
                    class="custom-control custom-control-inline custom-checkbox"
                  >
                    <validation-provider
                      name="recherche"
                      rules="required_if:pages,false"
                      v-slot="{}"
                      vid="trainings"
                    >
                      <input
                        type="checkbox"
                        name="trainings"
                        class="custom-control-input"
                        id="check-trainings-1"
                        :value="searchType.trainings"
                        v-model="searchType.trainings"
                      />
                      <label
                        class="custom-control-label"
                        for="check-trainings-1"
                        >{{ $t("trainings") }}</label
                      >
                    </validation-provider>
                  </div>
                  <div
                    class="custom-control custom-control-inline custom-checkbox"
                  >
                    <validation-provider
                      name="recherche"
                      rules="required_if:trainings,false"
                      v-slot="{}"
                      vid="pages"
                    >
                      <input
                        type="checkbox"
                        name="pages"
                        class="custom-control-input"
                        id="check-pages-3"
                        :value="searchType.pages"
                        v-model="searchType.pages"
                      />
                      <label class="custom-control-label" for="check-pages-3">{{
                        $t("pages")
                      }}</label>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="modal-footer pt-2">
                <div
                  v-if="q && !searchType.trainings && !searchType.pages"
                  class="text-center pb-1"
                >
                  <span class="text-danger">{{
                    $t("searchCategoryMessage")
                  }}</span>
                </div>
                <button
                  type="submit"
                  class="w-100 btn btn-primary"
                  :disabled="invalid"
                >
                  {{ $t("buttons.search") }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchModal",
  data() {
    return {
      searchType: {
        trainings: true,
        news: true,
        pages: true,
      },
      q: "",
    };
  },
  mounted() {
    $("#searchModal").on("hidden.bs.modal", (e) => {
      this.q = "";
      this.searchType.news = true;
      this.searchType.pages = true;
      this.searchType.trainings = true;
      this.$refs.form.reset();
    });
  },
};
</script>

<style scoped></style>
